<template>
	<span class="main-error">
		{{ error.message }}
	</span>
</template>

<script>
import { HIDE_ERROR_DELAY } from '../constants'

export default {
	name: 'MainError',

	props: {
		error: Object
	},

	mounted() {
		setTimeout(() => {
			this.$emit('remove', this.error.id)
		}, HIDE_ERROR_DELAY)
	}
}
</script>

<style lang="scss">
.main-error {
	position: absolute;
	top: 0;
	left: 50%;
	width: 500px;
	padding: 15px 30px;
	margin: 0 0 0 -250px;
	color: #fff;
	background: #e9576a;

	&::first-letter {
		text-transform: uppercase;
	}
}

@media (max-width: 767px) {
	.main-error {
		left: 0;
		margin: 0;
		width: 100%;
	}
}
</style>
